import { EnvTypes } from '../types/global'

export const isDev = () => process.env.REACT_APP_ENV === EnvTypes.dev
export const isStage = () =>
  process.env.REACT_APP_ENV === EnvTypes.stage
export const isProd = () =>
  process.env.REACT_APP_ENV === EnvTypes.prod
